import Image from 'next/image';
import MetaNavigation from './meta-navigation';
import FacebookImage from '../../../../../ui-kit/assets/logos/facebook.svg';
import YoutubeImage from '../../../../../ui-kit/assets/logos/youtube.svg';
import InstagramImage from '../../../../../ui-kit/assets/logos/instagram.svg';
import LinkedinImage from '../../../../../ui-kit/assets/logos/linkedin.svg';
import type { FC } from 'react';
import { EventClickElement } from '@tuic/tracking';
type SocialMediaIconsProps = {
  title?: string;
};

/**
 * Renders the group of social media icons.
 */
const SocialMediaIcons: FC<SocialMediaIconsProps> = ({
  title
}) => {
  return <div data-track-click-category="SocialMediaIcons" data-sentry-component="SocialMediaIcons" data-sentry-source-file="social-media-icons.tsx">
      {title && <MetaNavigation.Title>{title}</MetaNavigation.Title>}

      <ul className="m-0 flex list-none flex-wrap items-center justify-center gap-x-8 gap-y-3 p-0 pt-2.5 text-center lg:gap-x-3 lg:pt-0 lg:text-left">
        <li>
          <a href="http://www.facebook.com/MeinSchiff" target="_blank" className="flex lg:h-[2.375rem] lg:w-[2.375rem]" rel="noopener">
            <Image data-track-click-element={EventClickElement.Logo} data-track-click-label="facebook" src={FacebookImage} width={50} height={50} alt="Facebook" data-sentry-element="Image" data-sentry-source-file="social-media-icons.tsx" />
          </a>
        </li>
        <li>
          <a href="https://www.youtube.com/c/meinschiff" target="_blank" className="flex items-center lg:h-[2.375rem] lg:w-[2.375rem]" // centring the rectangular logo
        rel="noopener">
            <Image data-track-click-element={EventClickElement.Logo} data-track-click-label="youtube" src={YoutubeImage} width={50} height={50} alt="YouTube" data-sentry-element="Image" data-sentry-source-file="social-media-icons.tsx" />
          </a>
        </li>
        <li>
          <a href="https://instagram.com/meinschiffofficial/" target="_blank" className="flex lg:h-[2.375rem] lg:w-[2.375rem]" rel="noopener">
            <Image data-track-click-element={EventClickElement.Logo} data-track-click-label="instagram" className="p-[0.1645rem] lg:p-[0.125rem]" // visually harmonised logo
          src={InstagramImage} width={50} height={50} alt="Instagram" data-sentry-element="Image" data-sentry-source-file="social-media-icons.tsx" />
          </a>
        </li>
        <li>
          <a href="https://www.linkedin.com/company/tui-cruises-gmbh/" target="_blank" className="flex lg:h-[2.375rem] lg:w-[2.375rem]" rel="noopener">
            <Image data-track-click-element={EventClickElement.Logo} data-track-click-label="linkedin" className="p-[0.1645rem] lg:p-[0.125rem]" // visually harmonised logo
          src={LinkedinImage} width={50} height={50} alt="LinkedIn" data-sentry-element="Image" data-sentry-source-file="social-media-icons.tsx" />
          </a>
        </li>
      </ul>
    </div>;
};
export default SocialMediaIcons;